import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';
import { HttpClient } from '@angular/common/http';
import { GlobalService } from '../global/global.service';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class FirebaseService {
  message: any = null;
  notificationAPI = this.globalService.apiURL_UPGNotify;
  private notificationObs$: BehaviorSubject<any> = new BehaviorSubject(
    false
  );

    private notificationListObs$: BehaviorSubject<any> = new BehaviorSubject(
    []
  );
  constructor(private http: HttpClient, public globalService: GlobalService) {}

  getNotificationLoad(): Observable<any> {
    return this.notificationObs$.asObservable();
  }
  setNotificationLoadObs(data) {
    this.notificationObs$.next(data);
  }

  getNotificationListLoad(): Observable<any> {
    return this.notificationListObs$.asObservable();
  }
  setNotificationListLoadObs(data) {
    this.notificationListObs$.next(data);
  }


  requestPermissionToFirebaseServer() {
    const messaging = getMessaging();
    getToken(messaging,
      { vapidKey: environment.firebase.vapidKey }).then(
        (currentToken) => {
          if (currentToken) {
            console.log('Hurraaa!!! we got the token.....');
            console.log(currentToken);
          } else {
            console.log('No registration token available. Request permission to generate one.');
          }
        }).catch((err) => {
          console.log('An error occurred while retrieving token. ', err);
        });
  }

  listenFromFireBaseServer() {
    const messaging = getMessaging();
    onMessage(messaging, (payload) => {
      console.log('Message received. ', payload);
      this.message = payload;
    });
  }

  registerNotification(bodyObject): Observable<any> {
    return this.http.post(this.notificationAPI + '/notifications/register', bodyObject).pipe(
      map((x: Response) => x),
      map((x: any) => x),
      catchError((error: Response) => {
        return throwError(error);
      })
    );
  }

  unregisterNotification(bodyObject): Observable<any> {
    return this.http.post(this.notificationAPI + '/notifications/unregister', bodyObject).pipe(
      map((x: Response) => x),
      map((x: any) => x),
      catchError((error: Response) => {
        return throwError(error);
      })
    );
  }

  getAllNotificationByUser(user_id, cohortId): Observable<any> {
    return this.http.get(this.notificationAPI + '/notifications/cohorts/'+cohortId+'/get-all-by-user/' + user_id).pipe(
      map((x: Response) => x),
      map((x: any) => x),
      catchError((error: Response) => {
        return throwError(error);
      })
    );
  }


  updateIsSeenNotification(user_id, notification_id): Observable<any> {
    return this.http.patch(this.notificationAPI + '/notifications/users/' + user_id + '/messages/' + notification_id + '/update-is-seen', {}).pipe(
      map((x: Response) => x),
      map((x: any) => x),
      catchError((error: Response) => {
        return throwError(error);
      })
    );
  }
}
